<mat-card>
    <mat-card-header mat-dialog-title class="border-light border-bottom">
        <mat-card-title class="text-uppercase text-center login-header">Log In</mat-card-title>
    </mat-card-header>
    <mat-card-content mat-dialog-content class="position-relative login-content">
        <div class="d-block row">
            <mat-form-field class="col">
                <mat-label class="text-uppercase">Username</mat-label>
                <input matInput class="username" cdkfocusinitial autocomplete="name" [(ngModel)]="username">
            </mat-form-field>
            <mat-form-field class="col">
                <mat-label class="text-uppercase">Password</mat-label>
                <input matInput [(ngModel)]="password" type="password" autocomplete="off" (keydown.enter)="validateUser()">
            </mat-form-field>
            <div class="col text-center">
                <span *ngIf="msg | async as message" class="text-danger">{{message}}</span>
            </div>
        </div>
    </mat-card-content>
    <mat-card-footer mat-dialog-actions class="text-center">
        <div class="col-12">
            <button [disabled]="!username || !password" mat-raised-button color="primary" class="text-uppercase w-50" (keyup.enter)="validateUser()" (click)="validateUser()" >Sign in</button>
        </div>
        <div class="col d-flex text-center padding-10">
            <a class="col-6 requestLink" (click)="requestAccount()" >Request an Account</a>
            <a class="col-6 requestLink" (click)="forgotPassword()">Forgot Password?</a>
        </div>
    </mat-card-footer>
</mat-card>


